/*
 * @Description: 有关视图及布局应用的接口
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */

import { BaseService } from './base-service';
class LayoutService extends BaseService {
  /**
   * @description: 视图--获取对象的视图
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getObjectView(data) {
    return this.request({
      method: 'get',
      url: `/dynamic/view/all`,
      params: data
    });
  }

  /**
   * @description: 视图--获取对象的视图下的列表
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getObjectListPage(data) {
    const request = {
      method: 'post',
      url: `/dynamic/listPage`,
      data
    };
    if (data.groupkey) {
      request.params = { apiIndex: data?.groupkey || Math.random() };
    }
    return this.request(request);
  }
  /**
   * @description: 布局--列表页面配置字段
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getLayoutField(data) {
    return this.request({
      method: 'get',
      url: `/dynamic/layout/config/listPage`,
      params: data
    });
  }
  /**
   * @description: 布局--新增页面配置字段
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getLayoutAddModules(data) {
    return this.request({
      method: 'get',
      url: `/dynamic/layout/config/add`,
      params: data
    });
  }
  /**
   * @description: 布局--编辑页面配置字段
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  updateLayoutAddModules(data) {
    return this.request({
      method: 'get',
      url: `/dynamic/layout/config/update`,
      params: data
    });
  }
  /**
   * @description: 布局--详情页面配置字段
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getLayoutDetailModules(data) {
    return this.request({
      method: 'get',
      url: `/dynamic/layout/config/detail`,
      params: data
    });
  }
  /**
   * @description: 布局--新建/编辑时字段-满足条件必填/满足条件显示
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getLayoutfieldjoker(data) {
    return this.request({
      method: 'post',
      url: `/dynamic/joker`,
      params: { apiIndex: `${data.entity}-${Math.random() * 100}` },
      data
    });
  }
  /**
   * @description:对象--新增
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  add(data) {
    return this.request({
      method: 'post',
      url: `/dynamic/add`,
      data
    });
  }
  /**
   * @description: 对象--编辑
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  update(data) {
    return this.request({
      method: 'post',
      url: `/dynamic/update`,
      data
    });
  }
  /**
   * 对象--详情
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof salesOrderService
   */
  getDetail(params) {
    return this.request({
      method: 'get',
      url: `dynamic/layout/detail/module`,
      params
    });
  }
  /**
   *  布局详情--获取当前对象下所有字段信息
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof layoutService
   */
  getLayoutAllFields(params) {
    return this.request({
      method: 'get',
      url: `/dynamic/detailById`,
      params
    });
  }
  /**
   *  列表及详情--单个字段支持编辑
   /**
    * @description:
    * @return {*}
    * @author: 胡彩丽 hucaili@qfei.cn
    */

  editField(params) {
    return this.request({
      method: 'post',
      url: `/single/field/edit`,
      params: { apiIndex: params?.apiIndex || 0 },
      data: params
    });
  }
  /**
   *  线索转客户-商机页面初始化--新接口包含布局
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.clueId
   * @returns
   * @memberof LeadsService
   */
  clueConversionLayoutInit(data) {
    return this.request({
      method: 'post',
      url: `/entity/transform/layoutInit`,
      data
    });
  }
  /**
   *  线索转客户-商机------保存
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.clueId
   * @returns
   * @memberof LeadsService
   */
  saveLayoutTransform(data) {
    return this.request({
      method: 'post',
      url: `/entity/transform/layoutTransform`,
      data
    });
  }
  /**
   *  线索转客户-点击下一步时走的查重逻辑
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.clueId
   * @returns
   * @memberof LeadsService
   */
  layoutRepeatCheck(data) {
    return this.request({
      method: 'post',
      url: `/entity/transform/repeatCheck`,
      data
    });
  }
  /**
   *  保存分组条件
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer}
   * @returns
   * @memberof
   */
  saveOrUpdate(data) {
    return this.request({
      method: 'post',
      url: `/userListPageConfig/saveOrUpdate`,
      data
    });
  }
  /**
   *  获取分组字段
   *
   * @author nn
   * @param  {Object} data
   * @param  {integer}
   * @returns
   * @memberof
   */
  groupField(params) {
    return this.request({
      method: 'get',
      url: `/dynamic/layout/config/groupField`,
      params
    });
  }
  /**
   *  保存排序条件
   *
   * @author nn
   * @param  {Object} data
   * @param  {integer}
   * @returns
   * @memberof
   */
  saveSortOrUpdate(data) {
    return this.request({
      method: 'post',
      url: `/userListPageConfig/sort/saveOrUpdate`,
      data
    });
  }
  /**
   *  获取分组结构
   *
   * @author nn
   * @param  {Object} data
   * @param  {integer}
   * @returns
   * @memberof
   */
  groupStructure(data) {
    return this.request({
      method: 'post',
      url: `/dynamic/groupStructure`,
      data
    });
  }
  /**
   *  获取分组条件
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer}
   * @returns
   * @memberof LeadsService
   */
  userListPageConfigGet(params) {
    return this.request({
      method: 'get',
      url: `/userListPageConfig/get`,
      params
    });
  }
  /**
   *  清空排序条件
   *
   * @author nn
   * @param  {Object} data
   * @param  {integer}
   * @returns
   * @memberof LeadsService
   */
  sortClear(data) {
    return this.request({
      method: 'post',
      url: `/userListPageConfig/sort/clear`,
      data
    });
  }

  /**
   * @brief 设置看板列表字段
   */
  setDashboardFields(data) {
    return this.request({
      method: 'post',
      url: '/view/update/page/fields',
      data
    });
  }
  /**
   *  布局列表-批量导出(所有列表导出)
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param
   * @returns
   * @memberof LeadsService
   */
  listDownload(data) {
    return this.request({
      method: 'post',
      url: `/entity/upload/export/view`, //老接口：/entity/upload/export
      data
    });
  }

  /*************** 规则匹配相关接口 start *****************/
  /**
   * @brief 业务规则计算接口
   * @param data
   * @return {AxiosPromise}
   */
  fieldPermission(data) {
    return this.request({
      method: 'POST',
      url: '/entity/field/permission',
      data
    });
  }
  /**
   * @brief 业务规则计算接口-列表批量
   * @param data
   * @return {AxiosPromise}
   */
  permissionBatch(data, apiIndex = '') {
    return this.request({
      method: 'POST',
      url: '/entity/field/permission/batch',
      data,
      params: { apiIndex }
    });
  }
  /*************** 规则匹配相关接口 end *****************/
  //  默认值规则--获取参与筛选的字段
  getDefValFields(params) {
    return this.request({
      method: 'get',
      url: `/default/value/rel/fields`,
      params
    });
  }
  // 默认值规则--查询最新默认值值接口
  getDefNewVal(data, apiIndex = '') {
    return this.request({
      method: 'POST',
      url: `/default/value/new/values`,
      data,
      params: { apiIndex }
    });
  }
  // 默认值规则--子记录查询最新默认值值接口
  getSubDefNewVal(data, apiIndex = '') {
    return this.request({
      method: 'POST',
      url: `/default/value/subForm/new/value`,
      data,
      params: { apiIndex }
    });
  }
}
export const layoutService = new LayoutService();
